import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Crown, Heart, Sparkles, Instagram } from "lucide-react";

export default function About() {
  const { settings } = useAuth();
  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <div className="text-center mb-12">
        <Crown className="text-gold mx-auto mb-3" size={40} />
        <p className="font-script text-gold text-3xl">More Than Popcorn… It's a Mood!</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-black text-cream mt-1">About Overflow Popcorn Co.</h1>
      </div>

      <div className="gold-border-card rounded-2xl bg-card-surface p-8 space-y-5 text-cream/80 leading-relaxed">
        <p>Overflow Popcorn Co. is a family-owned gourmet snack business born out of a love for bringing people together over something delicious. Every batch of popcorn, every tin of cinnamon pecans, and every cookie is handcrafted in small batches with real ingredients and a whole lot of Southern love.</p>
        <p>From our signature <span className="text-gold">Red Velvet Pecan</span> and <span className="text-gold">Oreo Overload</span> popcorn to our warm, buttery cinnamon pecans and our "Dare to Be Different" gourmet cookies, we make snacks that turn ordinary moments into overflowing joy.</p>
        <p>Whether you're gifting, sharing, celebrating movie night, or treating your coworkers — we've got something delicious for everyone.</p>
        <div className="flex items-center gap-2 text-gold pt-2"><Sparkles size={18} /> <span className="font-serif text-lg">Sweet. Savory. Bold. Always Overflowing.</span></div>
      </div>

      <div className="grid sm:grid-cols-3 gap-5 mt-8">
        {[
          { t: "Handcrafted", d: "Small-batch, made fresh to order." },
          { t: "Premium Ingredients", d: "Real flavor, no shortcuts." },
          { t: "Southern Hospitality", d: "Made and served with love." },
        ].map((x) => (
          <div key={x.t} className="gold-border-card rounded-xl bg-card-surface p-6 text-center">
            <Heart className="text-gold mx-auto mb-2 fill-gold" size={22} />
            <h3 className="font-serif text-cream text-lg">{x.t}</h3>
            <p className="text-cream/60 text-sm mt-1">{x.d}</p>
          </div>
        ))}
      </div>

      <div className="text-center mt-10">
        <p className="text-cream/70">Follow us <span className="text-gold">{settings?.social?.instagram}</span></p>
        <p className="text-cream/70 mt-1">{settings?.email}</p>
        <Link to="/shop"><Button className="btn-gold rounded-full px-8 py-6 mt-6 font-semibold" data-testid="about-shop-btn">Start Your Order</Button></Link>
      </div>
    </div>
  );
}
